import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import GlobalStore from '../GlobalStore'

// import { refreshQuery } from "./authService/refreshApiSlice"
import { setError } from './errorService/errorSlice'
import { setAuthorized } from './authService/authSlice'

export const baseQuery = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_BASE_URL,
	prepareHeaders: (headers) => {
		const { access, guestCode } = GlobalStore.getStore()

		if (guestCode) {
			headers.set('x-auth-code', guestCode)
		} else if (access) {
			headers.set('authorization', `Bearer ${access}`)
		}

		return headers
	}
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
	const { dispatch } = api
	const { authorized, access, refresh } = GlobalStore.getStore()

	if (authorized && (!access || !refresh)) {
		dispatch(setAuthorized(false))
		GlobalStore.clear()
		GlobalStore.setItem('storage_wipe_reason', 'no_token/s')

		console.log('localStorage after checking of existen of tokens', localStorage)
		return
	}

	try {
		console.log('localStorage before basic request', localStorage)

		let result = await baseQuery(args, api, extraOptions)

		console.log('basic api result', result)

		if (result?.error && ((authorized && result?.error?.status !== 401) || result?.error?.originalStatus === 500)) {
			dispatch(setError(result?.error))
		}

		if (result?.error?.status === 401 && refresh) {
			console.log('refresh token after checking', refresh)

			const refreshQuery = fetchBaseQuery({
				baseUrl: process.env.REACT_APP_BASE_URL,
				method: 'POST',
				body: { refresh: refresh }
			})

			const refreshResult = await refreshQuery('/token/refresh/', api, extraOptions)

			console.log('refreshResult', refreshResult)

			if (refreshResult?.data) {
				GlobalStore.setItem('access', refreshResult?.data?.access)
				result = await baseQuery(args, api, extraOptions)
			} else {
				dispatch(setAuthorized(false))
				GlobalStore.clear()
				GlobalStore.setItem('storage_wipe_reason', 'refresh_token_invalid')

				console.log('localStorage after refresh was invalid', localStorage)
			}
		}

		return result
	} catch (e) {
		console.log('basic api catch error', e)
	}
}

export const apiSlice = createApi({
	baseQuery: baseQueryWithReauth,
	endpoints: builder => ({})
})